import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import type { RootState } from '../store'
import './SiteHeader.css'

type Props = {
  /** When true, section links use in-page anchors (#how). Off-page, they go to /#how. */
  homeAnchors?: boolean
}

export function SiteHeader({ homeAnchors = false }: Props) {
  const token = useSelector((s: RootState) => s.auth.accessToken)
  const { pathname } = useLocation()
  const [menuOpen, setMenuOpen] = useState(false)
  const signInTo = token ? '/app' : '/login'
  const signInLabel = token ? 'Continue' : 'Sign in'
  const section = (id: string) => (homeAnchors ? `#${id}` : `/#${id}`)
  const onAuth = pathname === '/login' || pathname === '/signup'

  useEffect(() => {
    setMenuOpen(false)
  }, [pathname])

  useEffect(() => {
    if (!menuOpen) return
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setMenuOpen(false)
    }
    window.addEventListener('keydown', onKey)
    document.body.style.overflow = 'hidden'
    return () => {
      window.removeEventListener('keydown', onKey)
      document.body.style.overflow = ''
    }
  }, [menuOpen])

  const close = () => setMenuOpen(false)

  return (
    <header className={`site-header${menuOpen ? ' is-open' : ''}`}>
      <div className="site-header__wrap">
        {homeAnchors ? (
          <a href="#top" className="site-header__logo" onClick={close}>
            <img src="/logo.png" alt="" width={38} height={38} />
            <span>
              DriveOps<span>.</span>
            </span>
          </a>
        ) : (
          <Link to="/" className="site-header__logo" onClick={close}>
            <img src="/logo.png" alt="" width={38} height={38} />
            <span>
              DriveOps<span>.</span>
            </span>
          </Link>
        )}

        <button
          type="button"
          className="site-header__burger"
          aria-expanded={menuOpen}
          aria-controls="site-header-nav"
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          onClick={() => setMenuOpen((v) => !v)}
        >
          <span />
          <span />
          <span />
        </button>

        <nav id="site-header-nav" className="site-header__nav" aria-label="Primary">
          <a href={section('how')} onClick={close}>
            How it works
          </a>
          <a href={section('features')} onClick={close}>
            Features
          </a>
          <a href={section('contact')} onClick={close}>
            Contact
          </a>
          <Link to={signInTo} className={`site-header__signin${onAuth ? ' is-current' : ''}`} onClick={close}>
            {signInLabel}
          </Link>
          <a href={section('download')} className="site-header__cta" onClick={close}>
            Get the app
          </a>
        </nav>
      </div>
      {menuOpen && <button type="button" className="site-header__scrim" aria-label="Close menu" onClick={close} />}
    </header>
  )
}
